'use client';

import { createContext, type ReactNode, useContext, useRef } from 'react';
import { type StoreApi, useStore } from 'zustand';
import { createVerificationStore, defaultInitState, type VerificationState, type VerificationStore } from './verificationStore';
export const VerificationStoreContext = createContext<StoreApi<VerificationStore> | null>(null);
export interface VerificationStoreProviderProps {
  children: ReactNode;
  initState?: VerificationState;
}
export const VerificationStoreProvider = ({
  children,
  initState
}: VerificationStoreProviderProps) => {
  const storeRef = useRef<StoreApi<VerificationStore> | undefined>(undefined);
  if (!storeRef.current) {
    storeRef.current = createVerificationStore(initState ?? defaultInitState);
  }
  return <VerificationStoreContext.Provider value={storeRef.current}>{children}</VerificationStoreContext.Provider>;
};
export const useVerificationStore = selector => {
  const verificationStoreContext = useContext(VerificationStoreContext);
  if (!verificationStoreContext) {
    throw new Error("useVerificationStore must be used within VerificationStoreProvider");
  }
  return useStore(verificationStoreContext, selector);
};